import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { useLocation, useHistory } from 'react-router-dom';
import { getCalendar } from 'flow/actions/extension-actions';
import ContactBox from 'flow/components/contact-card/ContactBoxTW';
import ContactScheduleEvents from 'flow/components/contact-card/ContactScheduleEvents';
import useAppContext from 'flow/hooks/useAppContext';
import { getExtension } from 'flow/selectors/ExtensionSelectors';
import { routes } from 'flow/types/routes';
import { generatePath } from 'flow/utils/router-utils';

interface ContactScheduleCardProps {
    extensionKey: string | null;
    // A calendar route in the host page's own section; without it the
    // colleague's calendar opens under Contacts.
    calendarPath?: string;
    onNavigation?: () => void;
}

const ContactScheduleCard: React.FC<ContactScheduleCardProps> = ({
    extensionKey,
    calendarPath,
    onNavigation,
}) => {
    const dispatch = useAppDispatch();
    const { i18next } = useAppContext();
    const { pathname } = useLocation();
    const history = useHistory();

    const calendar = useAppSelector((state) => {
        const extension = extensionKey
            ? getExtension(state, extensionKey)
            : null;
        return extension ? extension.get('calendar') : null;
    });

    useEffect(() => {
        if (extensionKey) {
            dispatch(getCalendar(extensionKey));
        }
    }, [dispatch, extensionKey]);

    if (!extensionKey) {
        return null;
    }

    const handleNavigate = () => {
        if (onNavigation) onNavigation();
        history.push(
            calendarPath ??
                generatePath(routes['extensions.entityKey.contact.calendar'], {
                    entityKey: extensionKey,
                }),
            { from: pathname },
        );
    };

    return (
        <ContactBox
            headerTitle={i18next.t('contact.calendar')}
            handleNavigate={handleNavigate}
        >
            {calendar ? <ContactScheduleEvents calendar={calendar} /> : null}
        </ContactBox>
    );
};

export default ContactScheduleCard;
